/**
 * 从 axios 错误中读取用户可读提示（与 main.js 中统一响应体 code/msg/data 配合）
 */
export function getApiErrorMessage(error, fallback = '请求失败') {
  if (!error) return fallback
  if (typeof error.message === 'string' && error.message.trim() !== '') {
    return error.message
  }
  const d = error.response && error.response.data
  if (d && typeof d === 'object' && !Array.isArray(d)) {
    const m = d.msg != null ? d.msg : d.message
    if (m != null && String(m).trim() !== '') return String(m)
  }
  return fallback
}
